export default {
	tabs: ["Deposit", "History"],
	History: {
		tabs: ["Reviewing", "Success", "Reject"]
	},
	AccountAmount: "Account Amount",
	ContactCustomerService: "Contact Customer Service",
	NoCustomerService: "Customer Service Busy",
	tips: "Kindly submit the previous rating before you proceed the next rating!"
};
